import { TranslationOptions } from 'owa-outlook-service-options';
import store from '../store/store';
import getTranslationOptions from 'owa-translation/lib/utils/getTranslationOptions';

export default function getTargetLanguageTag() {
    const options: TranslationOptions = getTranslationOptions();
    return options.targetLanguage ? options.targetLanguage : store.userLanguageTag;
}
